// frontend/src/pages/thinkrent/ThinkRentServicesList.jsx
import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import MainLayout from '../../layouts/MainLayout';
import Loader from '../../components/utils/Loader';
import Tooltip from '../../components/utils/Tooltip';
import './ThinkRent.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestion, faImage} from '@fortawesome/free-solid-svg-icons';
import QRCode from 'react-qr-code';
import ThinkRentScanQR from './ThinkRentScanQR';


const ThinkRentServicesList = () => {
    const authState = useSelector(state => state.authReducer);
    const navigate = useNavigate();
    const location = useLocation();
    const { categoryParam } = useParams(); 

    // console.log(categoryParam);

    const [category, setCategory] = useState(categoryParam || 'Car');
    const [userId, setUserId] = useState(authState.user._id);
    const [userName, setUserName] = useState(authState.user.name);
    const [userCode, setUserCode] = useState(authState.user.think5whyscode);

    const [rentalServiceList, setRentalServiceList] = useState([]);
    const [fetchData, { loading }] = useFetch();
    const [selectedServiceId, setSelectedServiceId] = useState([]);

    const [showAbout, setShowAbout] = useState(false);

    const buttonStyle = {
      marginLeft: '10px',
      padding: '5px 10px',
      fontSize: '14px',
      cursor: 'pointer',
      borderRadius: '5px',
      border: 'none',
      backgroundColor: '#25D366',
      color: '#fff'
    };

    const button1Style = {
      margin: '10px',
      padding: '10px',
      fontSize: '16px',
    };
    
   const fetchRentalServices = async () => {
      const config = { 
        url: "/rentalservice/bycategory", 
        method: "post", 
        headers: { Authorization: authState.token },
        data: { category: category}
      };
      // console.log("fetchRentalServices Config: ",config)
  
      fetchData(config, { showSuccessToast: false })
      .then(({ rentalServices }) => setRentalServiceList(rentalServices))
      .catch(error => console.error("Error fetching data:", error));
      };
  
    useEffect(() => {
      if (!authState.isLoggedIn) return;
      fetchRentalServices();
    }, [authState.isLoggedIn, category]);
  
    const sortedRentalServices = [...rentalServiceList].sort((a, b) => b.serviceName -a.serviceName);
  
    const handleServiceView = (_id) => {
      setSelectedServiceId(prevId => (prevId === _id ? null : _id));
    };

    // Call method
    const handleCallClick = (contactNumber) => {
      window.location.href = `tel:${contactNumber}`;
    };
  
    // WhatsApp method
    const handleWhatsAppClick = (contactNumber) => {
      const whatsappUrl = `https://wa.me/${contactNumber}`;
      window.open(whatsappUrl, '_blank');
    };
  
    // Email method
    const handleEmailClick = (contactEmail) => {
        window.location.href = `mailto:${contactEmail}`;
    };
    
    const formatDateTime = (date) => {
      const options = {
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit',
        hour12: false
      };
      const jsDate = new Date(date);
      const day = jsDate.getDate().toString().padStart(2, '0');
      const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
      const year = jsDate.getFullYear();
      const hours = jsDate.getHours().toString().padStart(2, '0');
      const minutes = jsDate.getMinutes().toString().padStart(2, '0');
      const seconds = jsDate.getSeconds().toString().padStart(2, '0');
      return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    };

    
  const handleShowAbout = () => {
    setShowAbout(!showAbout);
  };

  const handleMakePayment = () => {
    navigate("/wallet-topup");
  };

  const handleBookNow = () => {
    navigate("/think-rent-book-now");
  };

  return (
        <MainLayout>
          <div className="my-1 mx-auto py-1 min-w-full">
            <div className="text-white">
              <div className="my-2 mx-auto py-4">
                  {rentalServiceList.length !== 0 && <h2 className='my-2 ml-2 md:ml-0 text-yellow-300  border-b'>({rentalServiceList.length}) Services</h2>}
                  {loading ? (
                  <Loader />
                  ) : (
                  <div className="flex flex-col text-purple-500 text-m">
                      {rentalServiceList.length === 0 ? (
                      <div className='mt-4 my-4 p-4 text-yellow-300 text-lg rounded-md shadow-md border-b-2'>Currently there is no Services!!</div>
                      ) : (
                        sortedRentalServices.map((rentalService, index) => (
                          <div key={rentalService._id} className='bg-white my-1 p-4 text-gray-600 rounded-md shadow-md mt-4'>
                          <div className='flex flex-row mt-4'>
                              <span>{index + 1}. </span> {rentalService.serviceName}
                              <Tooltip text={"View details"} position={"top"}>
                              <span className='ml-auto mr-4 text-blue-500 cursor-pointer' onClick={() => handleServiceView(rentalService._id)}>
                                  <i className="fa-solid fa-eye"></i>
                              </span>
                              </Tooltip>
                          </div>
                          {selectedServiceId === rentalService._id && (
                            <div className='bg-gray-700 text-white mt-2 ml-4 mr-4 px-8'>
                              <p className='text-white flex justify-center text-xl mb-4'>{rentalService.serviceName}</p>
                              <p className='text-white flex justify-center text-xl mb-4'>{rentalService.category} rental by {rentalService.name}</p>
                              <p className='flex justify-center'>
                                <img 
                                  // src={`/api/downloads/rentals/images/${rentalService.rentalCode}.png`}
                                  src={`/api/downloads/rentals/images/RentalsNoImage.png`}
                                  alt="Service" 
                                  style={{ maxWidth: '100%', height: 'auto' }} 
                                />
                              </p>
                              <p className='flex flex-row justify-center mt-4 text-lg mb-4'><strong>Neighbourhood Servicing:</strong>{rentalService.neighbourhood}</p>
                              <div className="flex flex-col items-center w-full max-w-3xl mx-auto">
                                <div className="flex flex-row text-yellow-200 justify-center border-b border-gray-400 w-full">
                                  <div className='w-1/4 text-center p-2 border-r border-gray-400'>Hourly Rate</div>
                                  <div className='w-1/4 text-center p-2 border-r border-gray-400'>Daily Rate</div>
                                  <div className='w-1/4 text-center p-2 border-r border-gray-400'>Weekly Rate</div>
                                  <div className='w-1/4 text-center p-2'>Monthly Rate</div>
                                </div>
                                <div className="flex flex-row justify-center w-full">
                                  <div className='w-1/4 text-center p-2 border-r border-gray-400'>{rentalService.hourlyRate}</div>
                                  <div className='w-1/4 text-center p-2 border-r border-gray-400'>{rentalService.dailyRate}</div>
                                  <div className='w-1/4 text-center p-2 border-r border-gray-400'>{rentalService.weeklyRate}</div>
                                  <div className='w-1/4 text-center p-2'>{rentalService.monthlyRate}</div>
                                </div>
                              </div>
                              <p className='border-container min-w-screen mt-4 mb-4 bg-gray-800 text-white'><span dangerouslySetInnerHTML={{ __html: rentalService.about }} /></p>
                              <div className='border-container' > 
                                <p ><strong>Address:</strong> <span dangerouslySetInnerHTML={{ __html: rentalService.address }} /></p>
                                <p ><strong>PIN / Postal Code:</strong>{rentalService.pinCode}</p>
                              </div>
                              <div className='flex flex-row justify-center'>
                                  <button onClick={() => handleBookNow(rentalService._id)} style={buttonStyle}>
                                    <i className="fas fa-clipboard-check"></i> Book Now
                                  </button>
                                  <button onClick={() => handleCallClick(rentalService.contactNumber)} style={buttonStyle}>
                                  📞 Call
                                  </button>
                                  <button onClick={() => handleWhatsAppClick(rentalService.whatsappNumber)} style={buttonStyle}>
                                  💬 WhatsApp
                                  </button>
                                  <button onClick={() => handleEmailClick(rentalService.email)} style={buttonStyle}>
                                      ✉️ Email
                                  </button>
                              </div>
                            </div>
                          )}
                          </div>
                      ))
                      )}
                  </div>
                  )}
              </div>
            </div>
          </div>
        </MainLayout>
    );
};

export default ThinkRentServicesList;
